// extracted by mini-css-extract-plugin
export var active = "_dz-1";
export var circle = "_dz-0";
export var completed = "_dz-2";
export var connector = "_dz-4";
export var connectorCompleted = "_dz-7";
export var connectorSpacer = "_dz-5";
export var iconStrokeOverride = "_dz-8";
export var labelContainer = "_dz-6";
export var pending = "_dz-3";